import { apiProxyRequest } from "Api/apiProxyRequest";

import type { Variable, GetEnvironmentVariablesRequestType } from "./types";

export const getEnvironmentVariablesRequest = ({
  projectId,
  environmentId
}: GetEnvironmentVariablesRequestType) =>
  apiProxyRequest<Variable[]>(
    `/projects/${encodeURIComponent(projectId)}/environments/${encodeURIComponent(environmentId)}/variables`
  );
